/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePhaseDto } from '../../models/create-phase-dto';
import { ResponsePhaseDto } from '../../models/response-phase-dto';

export interface PhasesControllerCreate$Params {
  
    /**
     * The phase data to create
     */
    body: CreatePhaseDto
}

export function phasesControllerCreate(http: HttpClient, rootUrl: string, params: PhasesControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
  const rb = new RequestBuilder(rootUrl, phasesControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePhaseDto>;
    })
  );
}

phasesControllerCreate.PATH = '/thalea-pathways/phases';
